import React, { useEffect, useState } from 'react';
import { useIntl } from '../../util/reactIntl';
import { lazyLoadWithDimensions } from '../../util/uiHelpers';
import { StaticGoogleMap } from './StaticGoogleMap';
import DynamicGoogleMap from './DynamicGoogleMap';
import { fetchNearbyLandmarks, toCoordinates } from './nearbyLandmarks';

export const GoogleMapWithLandmarks = props => {
  const { center, mapsConfig, hiddenPlace, useStaticMap } = props;
  const { locale } = useIntl();
  const radius = Math.max(1000, Math.min(5000, (mapsConfig.fuzzy.offset || 500) * 3));
  const position = toCoordinates(hiddenPlace?.position);
  // An explicit identity prevents old results flashing when navigating listings,
  // even before the effect for the new location runs.
  const requestKey = JSON.stringify([
    center.lat,
    center.lng,
    radius,
    locale,
    hiddenPlace?.id,
    position?.lat,
    position?.lng,
  ]);
  const [result, setResult] = useState(null);
  useEffect(() => {
    let active = true;
    fetchNearbyLandmarks({ center, radius, language: locale, hiddenPlace })
      .then(landmarks => {
        if (active) setResult({ requestKey, landmarks });
      })
      .catch(() => {
        // Unavailable/disabled Places API must never restore unfiltered labels.
        if (active) setResult({ requestKey, landmarks: [] });
      });
    return () => {
      active = false;
    };
    // requestKey includes every input. Switching map modes reuses this result.
  }, [requestKey]);
  const landmarks = result?.requestKey === requestKey ? result.landmarks : [];
  const Component = useStaticMap ? StaticGoogleMap : DynamicGoogleMap;
  return <Component key={requestKey} {...props} landmarks={landmarks} />;
};

export default lazyLoadWithDimensions(GoogleMapWithLandmarks);
